import { render, staticRenderFns } from "./SettingsOption.vue?vue&type=template&id=7b5538c2"
import script from "./SettingsOption.vue?vue&type=script&lang=js"
export * from "./SettingsOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports